import { render, staticRenderFns } from "./AllotSuc.vue?vue&type=template&id=51ae2368&scoped=true"
import script from "./AllotSuc.vue?vue&type=script&lang=js"
export * from "./AllotSuc.vue?vue&type=script&lang=js"
import style0 from "./AllotSuc.vue?vue&type=style&index=0&id=51ae2368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae2368",
  null
  
)

export default component.exports